import CurrencySelectionModal from './curreny-selection-modal';
import './currency-selection-modal.scss';

export default CurrencySelectionModal;
